import React from "react";
import { Row, Col, Modal } from "react-bootstrap";
import { WithTranslation, withTranslation } from "react-i18next";
import { ICardToListOperation, IOperationData, ISelectCardOperation, ITextinputOperation, ITimeSlotOperation, OperationType, TranslationKeyType, IlistInputOperation, IListTextInputOperation } from "../../constants/types";
import Icon from "../icon/Icon";
import CardToListOperation from "./cardToListOperation/CardToListOperation";
import Operation from "./Operation";
import SelectCardOperationMinimized from "./selectCardOperation/SelectCardOperationMinimized";
import ListInputOperationMinimized from "./listInputOperation/ListInputOperationMinimized";
import ListTextInputOperationMinimized from "./listTextInputOperation/ListTextInputOperationMinimized";
import CardToListOperationMinimized from "./cardToListOperation/CardToListOperationMinimized";
import TextInputOperation from "./textInputOperation/TextInputOperation";
import TimeSlotOperation from "./timeSlotOperation/TimeSlotOperation";
import './OperationMinimized.scss';

interface Props extends WithTranslation {
    id: string,
    title: TranslationKeyType,
    operation: OperationType,
    data: IOperationData,
    goToPage: () => void,
    onChange: (changes: IOperationData) => void
};

interface State {
    showModal: boolean
};

class OperationMinimized extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            showModal: false
        }
    }

    renderData(operation: OperationType, data: IOperationData) {
        switch (operation.type) {
            case "INFO-PAGE":
                //Only display operation, should not display in submit
                return null;
            case "SELECT-CARD":
                return <SelectCardOperationMinimized operation={operation as ISelectCardOperation} data={data} />;
            case "TEXT-INPUT":
                //Not used and does not have minimized implemented
                return null;//<TextInputOperation operation={operation as ITextinputOperation} data={data} onChange={(changes) => { }} />;
            case "CARD-TO-LIST":
                return <CardToListOperationMinimized operation={operation as ICardToListOperation} data={data} />;
            case "TIME-SLOT":
                //Not used and does not have minimized implemented
                return null;//<TimeSlotOperation operation={operation as ITimeSlotOperation} data={data} onChange={(changes) => { }} />;
            case "LIST-INPUT":
                return <ListInputOperationMinimized operation={operation as IlistInputOperation} data={data} />;
            case "LIST-TEXT-INPUT":
                return <ListTextInputOperationMinimized operation={operation as IListTextInputOperation} data={data} />;
            default:
                return null;
        }
    }

    render() {
        const { t, id, title, operation, data, goToPage, onChange } = this.props;

        return <>
            <Modal key={`op-min-${id}-modal`} show={this.state.showModal} onHide={() => this.setState({ showModal: false })}>
                <Modal.Header closeButton>
                    {t(title as unknown as TemplateStringsArray)}
                </Modal.Header>
                <Modal.Body>
                    <Operation operation={operation} data={data} onChange={onChange} />
                </Modal.Body>
            </Modal>
            <Row key={`op-min-${id}-row`} className="render-operation-minimized" >
                <Col xs={10}>
                    <b>{t(title as unknown as TemplateStringsArray)}</b>
                </Col>
                <Col xs={2}>
                    <Icon type="BACKARROW" iconProps={{ size: '1.75rem' }} onClick={goToPage} />
                </Col>
                <Col xs={12}>
                    <div className={"data-row"}>
                        {this.renderData(operation, data)}
                    </div>
                </Col>
            </Row>
        </>;
    }
};

export default withTranslation()(OperationMinimized);